<template>
  <v-row class="bills-overview">
    <template v-if="permissions.financial.overview">
      <v-col cols="12" lg="4" md="4" sm="12">
        <div class="overview-info">
          <v-subheader>{{ lang.financial.bills.overview.all }}</v-subheader>
          <v-icon medium color="blue lighten-4">mdi-file-multiple-outline</v-icon>
          <span v-text="formatCurrency(value.total)"/>
        </div>
      </v-col>
      <v-col cols="12" lg="4" md="4" sm="12">
        <div class="overview-info">
          <v-subheader>{{ lang.financial.bills.overview.pending }}</v-subheader>
          <v-icon medium color="amber lighten-3">mdi-file-clock-outline</v-icon>
          <span v-text="formatCurrency(value.pending)"/>
        </div>
      </v-col>
      <v-col cols="12" lg="4" md="4" sm="12">
        <div class="overview-info">
          <v-subheader>{{ lang.financial.bills.overview.paid }}</v-subheader>
          <v-icon medium color="lime accent-4">mdi-file-check-outline</v-icon>
          <span v-text="formatCurrency(value.paid)"/>
        </div>
      </v-col>
    </template>
    <template v-else>
      <v-col cols="12">
        <span class="text-h4 pl-7 font-weight-medium">{{ lang.financial.bills.title_header }}</span>
      </v-col>
    </template>
  </v-row>
</template>

<script>
import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'

export default {
  mixins: [ appdata, utils ],
  props: {
    value: {
      type: Object,
      required: true
    }
  }
}
</script>
